module.exports = __webpack_public_path__ + "img/4组专业服务梯队.9832bb13.png";